import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { IndividualLicenseService } from '../individual-license.service';
import { IndividualLicenseModel } from '../../../model/individualLicenseModel';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from '../../../shared/spinner/spinner.service';

@Component({
  selector: 'app-individual-license',
  templateUrl: './individual-license.component.html',
  styleUrls: ['./individual-license.component.css']
})
export class IndividualLicenseComponent implements OnInit , OnDestroy{
 
  @Input()
  indivID: number;

  individualLicenseModel : IndividualLicenseModel;

  erroMessage : string="";
  constructor(private individualLicenseService :IndividualLicenseService,
              public activeModal: NgbActiveModal,
              private spinner : SpinnerService) { 

                this.spinner.show();

              }

  ngOnInit() {
    this.individualLicenseService.getIndividualLicense(this.indivID).subscribe(indivLicenseResp => {

      this.individualLicenseModel = indivLicenseResp;
      console.log("this.individualLicenseModel : ",this.individualLicenseModel)
      },
      err=>{
        this.erroMessage=err.message;
        console.log(err);
        console.log(this.indivID);
      })

    
  }
  ngOnDestroy(): void {
    this.activeModal.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/broker/view-pending-approvals/individual-license/individual-license.component.ts